if (!window.retailer) {
  window.retailer = {};
}

(function (retailer, debug) {
  function fillCompetitionIDSelect() {
    retailer.apiRobotList((data) => {
      data.data.forEach((item) => {
        competitionIdSelect.append(
          '<option data-owner="' +
            item.owner +
            '" data-id="' +
            item.competition_id +
            '" value="' +
            item.competition_id +
            '">' +
            item.competition_id +
            "</option>"
        );
      });
    });
  }
  function handleViewSummaryBtnClick() {
    function calcAverage(item) {
      let average = 0;
      if (item.resultDataArr.length > 0) {
        for (let i = 0; i < item.resultDataArr.length; i++) {
          average += Number(item.resultDataArr[i]);
        }
        average /= item.resultDataArr.length;
      }
      return average.toFixed(2) + "%";
    }
    function renderTable(data) {
      let view = "";
      let max_length = 0;
      let names = ["round"];
      for (let i = 0; i < data.data.length; i++) {
        let row = "<tr>";
        row += "<td>";
        row += data.data[i].studentName;
        names.push(data.data[i].studentName);
        row += "</td>";
        row += "<td>";
        row += calcAverage(data.data[i]);
        row += "</td>";
        row += "<td>";
        row += data.data[i].resultDataArr.length;
        if (data.data[i].resultDataArr.length > max_length)
          max_length = data.data[i].resultDataArr.length;
        row += "</td>";
        row += "<td>";
        row += '<input type="checkbox" name="' + (i + 1) + '">';
        row += "</td>";
        row += "</tr>";
        view += row;
      }
      return { view: view, max: max_length, names: names };
    }
    function handleCheckAll() {
      resultSummaryTable
        .find("tbody input[type=checkbox]")
        .prop("checked", selectAllCheckBox.prop("checked"));
      handleCheckBoxClick();
    }
    function handleCheckBoxClick() {
      let view = [0];
      resultSummaryTable.find("tbody input[type=checkbox]").each(function () {
        if ($(this).prop("checked")) {
          view.push(parseInt($(this).attr("name")));
        }
      });
      chart.setView({ columns: view });
      chart.draw();
    }
    function initState() {
      resultSummaryTable.find("thead th:nth-child(2)").click();
      let count = resultSummaryTable.find("tbody tr").length;
      for (let i = 1; i <= count; i++) {
        resultSummaryTable
          .find("tbody tr:nth-child(" + i + ")")
          .find("input[type=checkbox]")
          .prop("checked", true);
      }
      handleCheckBoxClick();
    }
    let competition_id = competitionResultSummaryInput.val();
    if (!competition_id) return;
    retailer.apiRobotRankList(competition_id, (data) => {
      selectAllCheckBox.prop("checked", false);
      let renderResult = renderTable(data);
      resultSummaryTable.find("tbody").html(renderResult.view);
      resultSummaryTable.find("tfoot td:last-child").html(data.rounds);
      let columns = [];
      for (let k = 0; k < renderResult.names.length; k++) {
        columns.push({ label: renderResult.names[k], type: "number" });
      }
      let dataSet = [columns];
      for (let i = 0; i < renderResult.max; i++) {
        let row = [i + 1];
        for (let j = 0; j < data.data.length; j++) {
          row.push(
            data.data[j].resultDataArr[i] == undefined
              ? null
              : Number(data.data[j].resultDataArr[i])
          );
        }
        dataSet.push(row);
      }
      //console.log(dataSet);
      let dataTable = google.visualization.arrayToDataTable(dataSet);
      options.hAxis.viewWindow.max = data.rounds;
      options.hAxis.format = "#"; // integer ticks on horizontal axis
      chart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "chart_div",
        dataTable: dataTable,
        options: options,
      });
      initState();
      resultSummaryTable
        .find("tbody input[type=checkbox]")
        .click(handleCheckBoxClick);
      selectAllCheckBox.click(handleCheckAll);
    });
  }

  function main() {
    competitionIdSelect = $(".competition-id-select");
    competitionIdSelect.combobox();
    competitionResultSummaryInput = $(
      'input.ui-combobox-input[name="competition_ID"]'
    );
    viewSummaryBtn = $(".competition-result-summary-btn");
    resultSummaryTable = $("#results-table");
    selectAllCheckBox = resultSummaryTable.find("thead input[name=all]");
    fillCompetitionIDSelect();
    viewSummaryBtn.click(handleViewSummaryBtnClick);
    sorttable.makeSortable(document.getElementById("results-table"));
  }
  let competitionIdSelect;
  let competitionResultSummaryInput;
  let viewSummaryBtn;
  let resultSummaryTable;
  let selectAllCheckBox;
  let chart;
  let options = {
    title: "Robot Progress",
    titleTextStyle: {
      color: "#494d55",
      fontSize: 24,
      fontName: "Arial",
      bold: true,
    },
    height: 600,
    width: "100%",
    legend: {
      position: "bottom",
      textStyle: {
        color: "#494d55",
        fontSize: 16,
        fontName: "Arial",
        bold: false,
      },
    },
    chartArea: { width: "80%", height: "80%" },
    backgroundColor: { fill: "transparent" },
    hAxis: {
      title: "Round",
      viewWindow: {
        min: 0,
      },
      textStyle: {
        color: "#494d55",
        fontSize: 16,
        fontName: "Arial",
        bold: false,
      },
      titleTextStyle: {
        color: "#494d55",
        fontSize: 20,
        fontName: "Arial",
        bold: true,
      },
    },
    vAxis: {
      title: "Performance%",
      viewWindow: {
        max: 100,
      },
      textStyle: {
        color: "#494d55",
        fontSize: 20,
        bold: false,
      },
      titleTextStyle: {
        color: "#494d55",
        fontSize: 20,
        bold: true,
      },
    },
  };
  google.charts.load("current", { packages: ["corechart", "line"] });
  google.charts.setOnLoadCallback(main);
})(window.retailer, window.retailer.debug);



// WEBPACK FOOTER //
// ../public/js/retailer.robot.js